"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicProductListsBySearchTerm = exports.getPublicProductList = exports.getProductListItem = exports.getCustomerProductLists = exports.getCustomerProductListItem = exports.getCustomerProductList = exports.getCustomerPaymentInstrument = exports.getCustomerOrders = exports.getCustomerBaskets = exports.getCustomerAddress = exports.getCustomer = void 0;
var _utils = require("../utils");
var _paramKeys = _interopRequireDefault(require("./paramKeys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

// TODO: Re-implement (and update description from RAML spec) when the endpoint exits closed beta.
// export const getExternalProfile: QueryKeyHelper<'getExternalProfile'> = {
//     queryKey: (params: Params<'getExternalProfile'>) => {
//         const paramKeys = [
//             ...paramKeysMap['getExternalProfile'],
//             ...getCustomKeys(getCustomerBaskets)
//         ]
//         return [...getExternalProfile.path(params), pick(params, paramKeys)]
//     }
// }

const getCustomer = exports.getCustomer = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomer'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomer.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerAddress = exports.getCustomerAddress = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/addresses/', params.addressName],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerAddress'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerAddress.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerBaskets = exports.getCustomerBaskets = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/baskets'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerBaskets'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerBaskets.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerOrders = exports.getCustomerOrders = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/orders'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerOrders'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerOrders.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerPaymentInstrument = exports.getCustomerPaymentInstrument = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/payment-instruments/', params.paymentInstrumentId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerPaymentInstrument'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerPaymentInstrument.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerProductLists = exports.getCustomerProductLists = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/product-lists'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerProductLists'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerProductLists.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerProductList = exports.getCustomerProductList = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/product-lists/', params.listId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerProductList'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerProductList.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCustomerProductListItem = exports.getCustomerProductListItem = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/customers/', params.customerId, '/product-lists/', params.listId, '/items/', params.itemId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCustomerProductListItem'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCustomerProductListItem.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getPublicProductListsBySearchTerm = exports.getPublicProductListsBySearchTerm = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/product-lists'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getPublicProductListsBySearchTerm'], ...(0, _utils.getCustomKeys)(params)];
    return [...getPublicProductListsBySearchTerm.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getPublicProductList = exports.getPublicProductList = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/product-lists/', params.listId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getPublicProductList'], ...(0, _utils.getCustomKeys)(params)];
    return [...getPublicProductList.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getProductListItem = exports.getProductListItem = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/product-lists/', params.listId, '/items/', params.itemId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getProductListItem'], ...(0, _utils.getCustomKeys)(params)];
    return [...getProductListItem.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};